import { InvitationsLandlord } from '../../components'
import React from 'react'

const Invitations = () => {
  return <InvitationsLandlord />
}

export default Invitations
